import React from "react";
import "./Footer.scss";
import elephant from "../../assets/images/elephant.png";
import footLogo from "../../assets/images/footlogo.png";
import twitter from "../../assets/images/twitter.svg";
import discord from "../../assets/images/discord.svg";
import telegram from "../../assets/images/telegram.svg";
import cope from "../../assets/images/cope.png";
import polygon from "../../assets/images/polygon.png";
import ygg from "../../assets/images/ygg.png";

import arrow from "../../assets/images/arrow-right.png";
import crysleft from "../../assets/images/crysleft.png";
import crysright from "../../assets/images/crysright.png";

function Footer() {
  return (
    <footer>
      <div className="crysleft">
        <img src={crysleft} alt="" />
      </div>
      <div className="crysright">
        <img src={crysright} alt="" />
      </div>
      <div className="container">
        <img src={elephant} alt="" className="elephant" />

        <div className="row newsletter">
          <div className="col-12 col-md-6"></div>

          <div className="col-12 col-md-6 subscribe ">
            <p className="susbcribe-text">Subscibe to our newsletter</p>
            <div className="input-container">
              <div className="input-inner">
                <input type="email" placeholder="Your email" required />
                <button>
                  <span className="sr-only">Submit</span>
                  <img src={arrow} alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-md-6 col-lg-4 ">
            <p className="footheading">Indi GG</p>
            <p className="subtext">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Ullamcorper enim tempor iaculis morbi malesuada purus hac.
            </p>
            <div className="socials">
              <a href="">
                <div className="social-item">
                  <img src={twitter} alt="" />
                </div>
              </a>
              <a href="">
                <div className="social-item">
                  <img src={discord} alt="" />
                </div>
              </a>
              <a href="">
                <div className="social-item">
                  <img src={telegram} alt="" />
                </div>
              </a>
            </div>
          </div>

          <div className="col-12  col-md-6 col-lg-4 footlogo text-center">
            <img src={footLogo} alt="" />
          </div>
        </div>

        <div className="copyright">© IndiGG 2021</div>

        <div className="row  pt-3">
          <div className="col-12 text-center text-white pt-3">
            <div className="built">
              <p className="collab">In collaboration with</p>
              <div style={{ display: "flex", alignItems: "center" }}>
                <a href="https://polygon.technology/" target="_blank">
                  <div className="built__icon">
                    <img
                      loading="lazy"
                      src={polygon}
                      alt="Polygon"
                      title="Polygon"
                    />
                  </div>
                </a>
                <a href="http://cope.studio" target="_blank">
                  <div className="built__icon">
                    <img
                      loading="lazy"
                      src={cope}
                      alt="COPE.STUDIO"
                      title="COPE.STUDIO"
                    />
                  </div>
                </a>

                <a href="https://yieldguild.io/" target="_blank">
                  <div className="built__icon">
                    <img loading="lazy" src={ygg} alt="ygg" title="ygg" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
